import printConfig from './printConfig.json';

// Single source of truth for print palette/typography
export const printPalette = printConfig.palette;
export const printTypography = printConfig.typography;
export const printPage = printConfig.page;
export const printInventory = printConfig.inventoryList;
export const printManifest = printConfig.freightManifest;
export const printInvoice = printConfig.invoice;